import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconLogo, LazyAppartementEntry, LazyBlokAppartementList, LazyBlokBanner, LazyBlokButton, LazyBlokContactAndMap, LazyBlokContentSection, LazyBlokDateEntry, LazyBlokDates, LazyBlokDefinitionList, LazyBlokDefinitionListEntry, LazyBlokFaq, LazyBlokFaqs, LazyBlokGoogleReviews, LazyBlokHeadline, LazyBlokHeadlineAndText, LazyBlokHikingReference, LazyBlokHikingStage, LazyBlokHikingStages, LazyBlokImageSlider, LazyBlokIntro, LazyBlokLinkList, LazyBlokLinkListItem, LazyBlokMoodImage, LazyBlokNavigationDownload, LazyBlokNavigationGoogle, LazyBlokNewsList, LazyBlokNote, LazyBlokPrice, LazyBlokPriceList, LazyBlokPriceLists, LazyBlokProfileCard, LazyBlokProfileList, LazyBlokRichtext, LazyBlokService, LazyBlokServices, LazyBlokSponsorHorse, LazyBlokSponsorship, LazyBlokTeaser, LazyBlokTeaserList, LazyBlokTeaserSection, LazyBlokTextMediaSection, LazyContentTypeArticle, LazyContentTypeWanderung, LazyPageCookiePolicy, LazyPagePrivacy, LazyThePage, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["IconLogo", LazyIconLogo],
["AppartementEntry", LazyAppartementEntry],
["BlokAppartementList", LazyBlokAppartementList],
["BlokBanner", LazyBlokBanner],
["BlokButton", LazyBlokButton],
["BlokContactAndMap", LazyBlokContactAndMap],
["BlokContentSection", LazyBlokContentSection],
["BlokDateEntry", LazyBlokDateEntry],
["BlokDates", LazyBlokDates],
["BlokDefinitionList", LazyBlokDefinitionList],
["BlokDefinitionListEntry", LazyBlokDefinitionListEntry],
["BlokFaq", LazyBlokFaq],
["BlokFaqs", LazyBlokFaqs],
["BlokGoogleReviews", LazyBlokGoogleReviews],
["BlokHeadline", LazyBlokHeadline],
["BlokHeadlineAndText", LazyBlokHeadlineAndText],
["BlokHikingReference", LazyBlokHikingReference],
["BlokHikingStage", LazyBlokHikingStage],
["BlokHikingStages", LazyBlokHikingStages],
["BlokImageSlider", LazyBlokImageSlider],
["BlokIntro", LazyBlokIntro],
["BlokLinkList", LazyBlokLinkList],
["BlokLinkListItem", LazyBlokLinkListItem],
["BlokMoodImage", LazyBlokMoodImage],
["BlokNavigationDownload", LazyBlokNavigationDownload],
["BlokNavigationGoogle", LazyBlokNavigationGoogle],
["BlokNewsList", LazyBlokNewsList],
["BlokNote", LazyBlokNote],
["BlokPrice", LazyBlokPrice],
["BlokPriceList", LazyBlokPriceList],
["BlokPriceLists", LazyBlokPriceLists],
["BlokProfileCard", LazyBlokProfileCard],
["BlokProfileList", LazyBlokProfileList],
["BlokRichtext", LazyBlokRichtext],
["BlokService", LazyBlokService],
["BlokServices", LazyBlokServices],
["BlokSponsorHorse", LazyBlokSponsorHorse],
["BlokSponsorship", LazyBlokSponsorship],
["BlokTeaser", LazyBlokTeaser],
["BlokTeaserList", LazyBlokTeaserList],
["BlokTeaserSection", LazyBlokTeaserSection],
["BlokTextMediaSection", LazyBlokTextMediaSection],
["ContentTypeArticle", LazyContentTypeArticle],
["ContentTypeWanderung", LazyContentTypeWanderung],
["PageCookiePolicy", LazyPageCookiePolicy],
["PagePrivacy", LazyPagePrivacy],
["ThePage", LazyThePage],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
